/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useState } from "react";
//#endregion
//#region Styles
import { Container } from "../styles";
//#endregion
//#region Components
import BackToView from "components/BackToView/BackToView";
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import Preloader from "components/Preloader/Preloader";
import DataHeaderDetail from "components/DataHeaderDetail/DataHeaderDetail";
import CustomTabs from "components/CustomTabs/CustomTabs";
import DialogAlertErrorSimple from "components/DialogAlertErrorSimple/DialogAlertErrorSimple";
import PenalizedStudentsTableList from "./PenalizedStudentsTableList/PenalizedStudentsTableList";
import EmptyData from "views/components/EmptyData/EmptyData";
import ToastMessage from "components/ToastMessage/ToastMessage";
import DialogAlertDeletePenalty from "./DialogAlertDeletePenalty/DialogAlertDeletePenalty";
//#endregion
//#region Icons
import StopIcon from "icons/StopIcon";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
import usePaginator from "components/Paginator/utils/hooks/usePaginator";
import useFilters from "./utils/hooks/useFilters";
import useStudentPenaltyList from "./utils/hooks/usePenaltyStudentList";
import useToastMessage from "components/ToastMessage/utils/hooks/useToastMessage";
import { getViewTabTitles } from "./utils/helpers";
import { INITIAL_TITLE_TAB_VIEWS } from "./utils/constants";
import useHandlerActions from "./utils/hooks/useHandlerActions";
import useDataRelatedToPenaltyAdmin from "./utils/hooks/useDataRelatedToPenaltyAdmin";
import useMainContext from "utils/context/useMainContext";
import useDashboardContext from "routes/utils/context/useDashboardContext";
import Header from "./Header/Header";
import UpdatePenaltyFormDialog from "./UpdatePenaltyFormDialog";
//#endregion

const SettingsPenaltyAdmin = () => {
    const mainContext = useMainContext();
    const { user } = useDashboardContext();
    //#region States
    const [currentTabIdx, setCurrentTabIdx] = useState(0);
    const [titleTabViews, setTitleTabViews] = useState(getViewTabTitles({ ...INITIAL_TITLE_TAB_VIEWS }));
    //#endregion
    //#region Fatal Error
    const [fatalError, setFatalError] = useState(false);
    useEffect(() => {
        mainContext.reloadForUnexpectedError(fatalError);
    }, [mainContext.showDialogUnexpectedError]);
    //#endregion
    const loadingRequest = useLoadingRequest();
    const toastMessage = useToastMessage();
    const paginator = usePaginator();
    const filters = useFilters();
    const {
        studentPenaltyList,
        searchedFilters,
        dialogs: {
            dialogShowErrorWhenStudentIdIsLessThan5Characters
        },
        idOfPenaltyToBeOpenedAfterAfterPerforingTheAction
    } = useStudentPenaltyList({
        filters,
        paginator,
        currentTabIdx,
        setTitleTabViews,
        notifications: {
            loadingRequest,
            toastMessage
        },
        setFatalError
    });
    const dataRelatedToPenaltyAdmin = useDataRelatedToPenaltyAdmin({
        setFatalError, loadingRequest, 
        userRole: user.role.id
    });
    const handlerActions = useHandlerActions({
        loadingRequest,
        fillStudentPenaltyList: studentPenaltyList.fill
    });
    const { dialogs, actions, currentPenaltyStudentForDoAction } = handlerActions;
    //#region Functions
    const changeCurrentTabIdx = value => {
        setCurrentTabIdx(value);
        studentPenaltyList.setTriggerRequest(true);
    }
    const notExistPenalizedStudents = () => {
        return loadingRequest.value.hidden && (!studentPenaltyList.value || !studentPenaltyList.value.length);
    }
    //#endregion
    return (
        <>
            <HelmetUTP title="Admin. de sanciones" />
            <ToastMessage {...toastMessage.value} />
            <BackToView to={ABSOLUTE_PATHS.SETTINGS} text="Volver a Configuración" />
            <Preloader {...loadingRequest.value} />
            <Container>
                <DataHeaderDetail
                    icon={<StopIcon />}
                    text="Administrador de Sanciones"
                    width="300px" />
                <Header
                    searchedFilters={searchedFilters}
                    filters={filters}
                    paginator={paginator}
                    studentPenaltyList={studentPenaltyList} />
                <CustomTabs
                    viewTabTitles={titleTabViews}
                    currentTabIdx={currentTabIdx}
                    changeCurrentTabIdx={changeCurrentTabIdx}
                    tabWidth={120} />
                {notExistPenalizedStudents()
                    ? <EmptyData
                        content={<>Actualmente <b>no existen registros</b> de sanciones vigentes. </>} />
                    : <PenalizedStudentsTableList
                        loadingRequest={loadingRequest}
                        idOfPenaltyToBeOpenedAfterAfterPerforingTheAction={idOfPenaltyToBeOpenedAfterAfterPerforingTheAction}
                        studentPenaltyList={studentPenaltyList}
                        actions={actions.openDialog}
                        currentTabIdx={currentTabIdx} />}
            </Container>
            <UpdatePenaltyFormDialog
                dialog={dialogs.dialogUpdatePenaltyStudent}
                loadingRequest={loadingRequest}
                data={dataRelatedToPenaltyAdmin}
                currentPenaltyForm={currentPenaltyStudentForDoAction.value}
                updateAction={actions.apply.updateAction} />
            <DialogAlertDeletePenalty
                dialogShow={dialogs.dialogDeletePenaltyStudent}
                deleteAction={actions.apply.deleteAction} />
            <DialogAlertErrorSimple
                dialogShow={dialogShowErrorWhenStudentIdIsLessThan5Characters}
                title="No se puede realizar la búsqueda"
                content="Debes escribir al menos 5 caracteres." />
        </>
    );
}

export default SettingsPenaltyAdmin;